import { usePWA } from "@/hooks/usePWA";
import { PWAUpdatePrompt } from "@/components/PWAUpdatePrompt";
import { useToast } from "@/hooks/use-toast";
import { useEffect } from "react";

export function PWAProvider({ children }: { children: React.ReactNode }) {
  const { needRefresh, offlineReady, updateServiceWorker, dismissUpdate } = usePWA();
  const { toast } = useToast();

  // Show toast when offline ready (first install)
  useEffect(() => {
    if (offlineReady) {
      toast({
        title: "Application prête",
        description: "REGARD DE NATURE est maintenant disponible hors ligne.",
      });
    }
  }, [offlineReady, toast]);

  return (
    <>
      {children}
      {needRefresh && (
        <PWAUpdatePrompt
          onUpdate={updateServiceWorker}
          onDismiss={dismissUpdate}
        />
      )}
    </>
  );
}
